import {Component, OnInit, inject, input} from '@angular/core';
import {DataService} from '../../../global/services/data.service';
import dayjs from 'dayjs';
import {UserService} from '../../../global/services/user.service';
import {Router} from '@angular/router';
import {CryptoService} from '../../../global/services/crypto.service';
import {FormService} from '../../../global/services/form.service';
import {ViewMode, UrlData} from '../../../interfaces';
import {NgIf, NgFor, NgClass, DatePipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TooltipDirective} from 'ngx-bootstrap/tooltip';
import {TaskStatusPipe} from '../../../global/pipes/task-status.pipe';
import {RightPipe} from '../../../global/pipes/right.pipe';

@Component({
    selector: 'app-task-date-own',
    templateUrl: './task-date-own.component.html',
    styleUrl: './task-date-own.component.scss',
    imports: [NgIf, FormsModule, NgFor, NgClass, TooltipDirective, DatePipe, TaskStatusPipe, RightPipe]
})
export class TaskDateOwnComponent implements OnInit {

    formService = inject(FormService);
    userService = inject(UserService);
    private dataService = inject(DataService);
    private router = inject(Router);
    private cryptoService = inject(CryptoService);

    TID = input.required<any>();
    ownTask = input.required<boolean>();

    taskDates!: any[];
    taskDateFilter: any;
    document: any;

    done = 0;
    inProgress = 0;
    open = 0;
    wait = 0;
    generated = 0;

    taskRecurring = false;
    hideCompleted = true;

    ngOnInit(): void {
        this.taskDateFilter = {
            number: 1,
            interval: 'month'
        };

        this.listTaskDates();
    }

    listTaskDates(): void {
        this.dataService.request('TaskDate/listByTask', {
            TID: this.TID(),
            end: dayjs().add(this.taskDateFilter.number, this.taskDateFilter.interval).format('YYYY-MM-DD')
        }).subscribe(response => {
            this.document = response.document;
            this.taskDates = response.taskDates;

            this.done = this.taskDates.filter(taskDate => taskDate.status === 'done').length;
            this.inProgress = this.taskDates.filter(taskDate => taskDate.status === 'in_progress').length;
            this.open = this.taskDates.filter(taskDate => taskDate.status === 'open').length;
            this.wait = this.taskDates.filter(taskDate => taskDate.status === 'wait').length;
            this.generated = this.taskDates.filter(taskDate => taskDate.status === 'generated').length;

            this.taskRecurring = response.task.type === 'recurring';
        });
    }

    createTaskDate(): void {
        const urlData: UrlData = {
            ID: '0',
            data: {
                TID: this.TID()
            },
            viewMode: ViewMode.INSERT,
        };

        this.router.navigate(['/app/taskdate/detail/', this.cryptoService.encrypt(urlData)]);
    }

    openTaskDate(taskDate: any): void {
        const urlData: UrlData = {
            ID: taskDate.TDID,
            data: {
                TID: taskDate.TID
            },
            viewMode: taskDate.TDID === '0' ? ViewMode.INSERT : ViewMode.VIEW,
        };

        // pass start_date and end_date of generated taskdates
        if (taskDate.TDID === '0') {
            // there is no start_date for singular tasks
            urlData.data.start_date = taskDate.start_date ? dayjs(taskDate.start_date).format('YYYY-MM-DD') : null;
            urlData.data.end_date = dayjs(taskDate.end_date).format('YYYY-MM-DD');
        }
        this.router.navigate(['/app/taskdate/detail/', this.cryptoService.encrypt(urlData)]);
    }
}
